import thunk from 'redux-thunk';
import { debounce } from 'lodash';
import { reducers } from './reducers/index';
import { loadState, saveState } from './utils/localStorage';
import { applyMiddleware, createStore, StoreCreator } from 'redux';

interface ExtendedWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION__: () => ((creator: StoreCreator) => StoreCreator);
}

const ewindow = window as unknown as ExtendedWindow;

const devStore = (ewindow.__REDUX_DEVTOOLS_EXTENSION__
  ? ewindow.__REDUX_DEVTOOLS_EXTENSION__()(createStore)
  : createStore);

const createStoreWithMiddleware = applyMiddleware(thunk)(devStore);
// tslint:disable-next-line:no-any
export const store = createStoreWithMiddleware(reducers, loadState()) as any;

store.subscribe(debounce(
  () => {
    const { email, token, uid, sysadmin } = store.getState().auth;
    saveState({
      auth: { email, token, uid, sysadmin }
    });
  },
  500
));

export default store;